module.exports = __webpack_public_path__ + "img/image-footer-1.08ea8de7.png";